import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom"; // if using react-router
// If NOT using Router, I will give the non-router version below.
import {
    Server,
    FileText,
    LayoutDashboard,
    Activity,
    Target
} from 'lucide-react';

const TopNavigation = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const showParam = queryParams.get("show") || "dashboard";

    const [active, setActive] = useState(showParam);

    const navItems = [
        {name: "Overview", key: "overview", icon: LayoutDashboard},
        {name: "Live Processing Document List", key: "processingDataTable", icon: FileText},
        {name: "Processing Stages", key: "bullDashboard", icon: Server},
        {name: "Processing Performance", key: "report", icon: Activity},

    ];

    // Sync active tab with browser URL
    useEffect(() => {
        setActive(showParam);
    }, [showParam]);

    const handleClick = (key) => {
        setActive(key);

        // Update URL like ?show=dashboard
        const params = new URLSearchParams(location.search);
        params.set("show", key);
        navigate(`?${params.toString()}`, {replace: true});
    };

    return (
        <div>
            <div className="d-flex justify-content-center align-items-center my-4">
                <h1 className="drm-heading">
                    FILE PROCESSING <span className="drm-sub">(NEXT GEN)</span>
                    <span className="drm-env">
                        {process.env.REACT_APP_PLATFORM}
                    </span>
                </h1>
            </div>

            <div className="flex justify-center mb-8">

                <nav
                    className="flex items-center gap-1 bg-white/80 dark:bg-slate-800/80 backdrop-blur-md p-1.5 rounded-full border border-slate-200 dark:border-slate-700 shadow-sm relative">

                    {navItems.map((item) => {
                        const isActive = active === item.key;

                        return (
                            <button
                                key={item.key}
                                onClick={() => handleClick(item.key)}
                                className={`
                relative flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ease-out
                ${
                                    isActive
                                        ? "text-white shadow-md scale-105"
                                        : "text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-white hover:bg-slate-100 dark:hover:bg-slate-700/50"
                                }
              `}
                            >
                                {isActive && (
                                    <span
                                        className="absolute inset-0 bg-blue-600 rounded-full -z-10 transition-all duration-300"/>
                                )}

                                <item.icon
                                    size={16}
                                    className={isActive ? "animate-pulse" : ""}
                                />
                                {item.name}

                                {item.alert && (
                                    <span
                                        className={`absolute top-2 right-2 flex h-2 w-2 ${
                                            isActive ? "translate-x-1 -translate-y-1" : ""
                                        }`}
                                    >
                  <span
                      className="animate-ping absolute inline-flex h-full w-full rounded-full bg-rose-400 opacity-75"></span>
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-rose-500"></span>
                </span>
                                )}
                            </button>
                        );
                    })}
                </nav>
            </div>
        </div>
    );
};

export default TopNavigation;
